import { ComputedRef, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import {
    CommonListFilterParameters,
    ListFilterModel,
    PaginationCommonFilter,
    PaginationParameters,
    PaginationRequestProps
} from '@/views/_shared/search-list/types'
import { storeFormModel } from '@/modules/_shared/forms'
import _ from 'lodash'

export function useAPIPagination (
    filter: CommonListFilterParameters,
    fetchItemsCallback: (agr: any) => Promise<void>,
    itemCount: ComputedRef<number | undefined>,
    currentRoutePage: ComputedRef<string | (string | null)[]>,
    isSimpleFilterType = false,
    useFilterCachingTag = '',
    callBackParam?: string) {
    const loading = ref(false)
    const pagination = ref<PaginationParameters>({
        rowsPerPage: filter.limit,
        rowsNumber: itemCount.value || 0,
        page: +currentRoutePage.value || 1,
        descending: false,
        sortBy: null
    })

    const router = useRouter()

    const onRequest = async (props: PaginationRequestProps) => {
        loading.value = true
        const currentPage = props.pagination.page
        const rowsPerPage = props.pagination.rowsPerPage
        const sortBy = pagination.value.sortBy = props.pagination.sortBy
        const sortDescending = pagination.value.descending = props.pagination.descending
        if (sortBy !== null) {
            filter.sortBy = sortBy + ' ' + (sortDescending ? 'desc' : 'asc')
        } else {
            filter.sortBy = ''
        }
        pagination.value.rowsPerPage = filter.limit = rowsPerPage
        pagination.value.page = currentPage
        filter.offset = (currentPage - 1) * rowsPerPage
        if (isSimpleFilterType) {
            filter.search = props.filter || ''
        } else {
            filter.search = props.filter || {} as PaginationCommonFilter
        }
        await fetchItemsCallback(callBackParam)

        if (currentRoutePage.value.length !== 0) {
            const routeQuery = Object.assign({}, { query: { page: currentPage.toString() } })

            if (useFilterCachingTag) {
                if (isSimpleFilterType) {
                    storeFormModel({ value: props.filter } as ListFilterModel, useFilterCachingTag)
                } else {
                    storeFormModel(props.filter as ListFilterModel, useFilterCachingTag)
                }
            }

            router.push(routeQuery)
        }
        loading.value = false
    }

    watch(currentRoutePage, _.debounce(() => {
        if (+currentRoutePage.value !== +pagination.value.page) {
            pagination.value.page = +currentRoutePage.value
            onRequest({
                filter: filter.search,
                pagination: pagination.value
            })
        }
    }, 500))

    watch(itemCount, count => {
        pagination.value.rowsNumber = count
    })
    return {
        loading,
        pagination,
        onRequest,
        currentRoutePage
    }
}
